export function isGoogleTagManagerEnabled(): boolean {
  if (import.meta.env.DEV) {
    return false;
  }

  const googleTagManagerId =
    (import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID as string | undefined)
      ?.trim() ?? '';

  return googleTagManagerId.length > 0;
}
